import React, {useState} from "react";
/** @jsxImportSource @emotion/react */
import {css} from "@emotion/react";
import {useTheme} from "@emotion/react";
import {temporary_actions} from "../../../redux/slice/TemporaryReducer";
import {useDispatch, useSelector} from "react-redux";
import {ROUND_BOX} from "../../_presentational/buttons";

const AutoPlayButton = () => {
    const dispatch = useDispatch();
    const temporary_reducer = useSelector((state) => state.temporary_reducer);

    // state
    const [is_auto_play, setIsAutoPlay] = useState(temporary_reducer?.auto_play_check || false);

    // css style
    const {css} = useComponentStyle(is_auto_play);

    const onAutoPlayCheck = () => {
        const auto_play_check = !is_auto_play;
        setIsAutoPlay(auto_play_check);
        dispatch(
            temporary_actions.setValue({
                key: "auto_play_check",
                value: auto_play_check,
            })
        );
    };

    return (
        <div onClick={() => onAutoPlayCheck()}>
            <ROUND_BOX css={css.auto_play_button_css}>{is_auto_play ? "ON" : "OFF"}</ROUND_BOX>
        </div>
    );
};

export default AutoPlayButton;

export const useComponentStyle = (is_auto_play) => {
    const theme = useTheme();
    return {
        css: {
            auto_play_button_css: css({
                padding: ".3em 0",
                cursor: "pointer",
                width: "4em",
                border: is_auto_play ? `2px solid ${theme.colors.bearu_primary}` : `2px solid ${theme.colors.dg3}`,
                backgroundColor: is_auto_play ? theme.colors.bearu_primary : theme.colors.w,
                color: is_auto_play ? theme.colors.w : theme.colors.dg1,
                fontWeight: "700",
                transition: "all .2s",
                "&:active": {
                    backgroundColor: is_auto_play ? theme.colors.w : theme.colors.bearu_primary,
                    color: is_auto_play ? theme.colors.dg1 : theme.colors.w,
                },
                "@media (max-width: 280px)": {
                    width: "3.2em",
                },
            }),
        },
    };
};
